(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["palette-color-hover"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.palette-section');
    if (!section) return;
    var items = Array.from(section.querySelectorAll('.palette-item'));
    var isTouch = window.matchMedia('(hover: none)').matches;

    if (!isTouch) {
      document.addEventListener('mousemove', function (e) {
        var mouseX = e.clientX / window.innerWidth - 0.5;
        var mouseY = e.clientY / window.innerHeight - 0.5;
        items.forEach(function (item, i) {
          if (!item.matches(':hover')) {
            var speed = ((i % 3) + 1) * 0.5;
            item.style.translate = (mouseX * speed * 10) + 'px ' + (mouseY * speed * 10) + 'px';
          }
        });
      });

      document.addEventListener('mouseleave', function () {
        items.forEach(function (item) {
          if (!item.matches(':hover')) item.style.translate = '';
        });
      });

      items.forEach(function (item) {
        item.addEventListener('mouseenter', function () {
          item.style.zIndex = '20';
        });
        item.addEventListener('mouseleave', function () {
          setTimeout(function () { item.style.zIndex = ''; }, 600);
        });
      });
    }

    items.forEach(function (item) {
      item.addEventListener('click', function (e) {
        var isRevealed = item.classList.contains('is-revealed');
        items.forEach(function (other) {
          other.classList.remove('is-revealed');
          other.style.zIndex = '';
        });
        if (!isRevealed) {
          item.classList.add('is-revealed');
          item.style.zIndex = '20';
        }
        e.stopPropagation();
      });
    });

    document.addEventListener('click', function () {
      items.forEach(function (item) {
        item.classList.remove('is-revealed');
        setTimeout(function () { item.style.zIndex = ''; }, 600);
      });
    });

    if (isTouch) {
      var hinted = new Set();
      var observer = new IntersectionObserver(function (entries) {
        var batch = entries.filter(function (en) {
          return en.isIntersecting && !hinted.has(en.target);
        });
        batch.forEach(function (en, i) {
          var el = en.target;
          hinted.add(el);
          setTimeout(function () {
            el.classList.add('is-hinting');
            el.addEventListener('animationend', function () {
              el.classList.remove('is-hinting');
            }, { once: true });
          }, i * 120);
          observer.unobserve(el);
        });
      }, { threshold: 0.4 });

      items.forEach(function (item) { observer.observe(item); });
    }

    window.addEventListener('load', function () {
      items.forEach(function (item, i) {
        item.style.opacity = '0';
        item.style.translate = '0 30px';
        setTimeout(function () {
          item.style.transition = 'opacity 0.8s cubic-bezier(0.16,1,0.3,1), translate 0.8s cubic-bezier(0.16,1,0.3,1)';
          item.style.opacity = '1';
          item.style.translate = '';
        }, i * 80);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
